import styled, { ITheme } from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const StatusWrapper = styled.div<IWithSize & IExpenderProps>`
  display: flex;
  background-color: ${({ isNoPick }: IExpenderProps) =>
    isNoPick ? '#FFF' : ({ theme }: ITheme) => theme.colors.palette.paleGrey};
  align-items: center;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  letter-spacing: 0.1px;

  &:hover {
    transition: all 0.3s;
    background-color: ${({ theme }: ITheme) => theme.colors.palette.paleGrey}
    cursor: ${({ isNoPick }: IExpenderProps) =>
      isNoPick ? 'pointer' : 'default'};
  }
`

interface IExpenderProps {
  isNoPick?: boolean
}

export default StatusWrapper
